
export default {
  data() {
    return {
      levels: [
        {
          title: "تحریم‌شکن به‌عنوان راهکار",
          cap: "اگر در توسعه یا اجرای زیرساخت ابری خود با محدودیت‌های زیر که ناشی از تحریم هستند، مواجه می‌شوید، تحریم‌شکن آبالون برای شما طراحی شده است.",
          items: [
            "دانلود ایمیج‌ها و درایورها",
            "دریافت دیتاست‌های خارجی",
            "استفاده از APIهای بین‌المللی",
            "رفع خطا هنگام دریافت ایمیج‌ها",
            "کار با سرویس‌های SaaS",
            "ارتباط با پلتفرم‌های Cloud",
            "دسترسی به Docker Hub",
            "دسترسی به GitHub",
            "اجرای محیط‌های CI/CD",
          ],
        },
        {
          title: "لودبالانسر به‌عنوان راهکار",
          cap: "اگر از درگاه‌های خدماتی یا سرویس‌های زیر استفاده می‌کنید که به‌دلیل بار ترافیک، کند یا غیرقابل دسترس می‌شوند، راهکار لودبالانسر آبالون مناسب شما است.",
          items: [
            "وب‌سایت‌های پربازدید",
            "اپلیکیشن‌های آنلاین",
            "درگاه‌های خدماتی و دولتی",
            "زیرساخت با معماری توزیع‌شده",
            "تضمین پایداری در اوج ترافیک",
            "پلتفرم‌های تجارت الکترونیک",
            "خدمات عمومی (پلیس، اورژانس و …)",
            "فروشگاه‌های آنلاین",
            "فروشگاه‌های زنجیره‌ای",
          ],
        },
      ],
      activeTab: 0,
    };
  },
  methods: {
    handleScroll(index) {
      let perviuos = this.activeTab;
      this.activeTab = index;
      const element = document.getElementById(`cards`);

      if (index + 1 > perviuos) {
        element.scrollLeft -= (index + 1) * 200;
      } else {
        element.scrollLeft += (index + 1) * 300;
      }
    },
  },
};
